import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RumActionTrackerService } from '../services/rum-action-tracker.service';

@Injectable()
export class ApprovalSubmitTrackingInterceptor implements HttpInterceptor {
	constructor(private rumActionTracker: RumActionTrackerService) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const shouldTrackSubmitForApproval =
			req.method?.toUpperCase() === 'POST' && (req.url || '').split('?')[0].toLowerCase().endsWith('/approval');

		// Track at request time so it aligns with "Submit for Approval" POST being sent.
		if (shouldTrackSubmitForApproval) {
			this.rumActionTracker.trackAction('Submit', { formType: this.rumActionTracker.getCurrentViewName() });
		}

		return next.handle(req);
	}
}
